<div class="home-container">
  <div class="banner-module">
    <div id="banner" class="banner">
      <div [@bounce]="bounce" id="greet" class="greet-text">
        <h1>Hi!,</h1>
        <h2><span>I'm </span><span id="name">Naresh Kumar</span></h2>
        <h3>Full Stack Web Developer, AI Enthusiast</h3>
        <div class="greet-button">
          <button class="contact-button" mat-button routerLink="/contact">Wanna Reach Out?</button>
          <!-- <button class="help-button" mat-button routerLink="/help">How can I Help You?</button> -->
        </div>
      </div>
    </div>
  </div>
</div>
